<script>
import InputEmitButton from './InputEmitButton.vue';
import RedactorControl from '../RedactorControl.vue';

export default {
    components: {
        InputEmitButton,
        RedactorControl
    },

    props: {
        jobProfile: {
            type: Object,
            required: true
        },
        compact: {
            type: Boolean,
            default: false
        },
        inputsClickable: {
            type: Boolean,
            default: false
        },
        expand: {
            type: Boolean,
            default: false
        },
        twoColumn: {
            type: Boolean,
            default: false
        },
        readonlyGridPosition: {
            type: String,
            default: 'items-center'
        }
    },

    methods: {
        removePTag(str) {
            if (str === null || str === undefined) {
                return '';
            }
            return str.replace(/<p>/g, '').replace(/<\/p>/g, '');
        },
    },

    data() {
        return {
            expanded: this.expand
        }
    },
}
</script>

<template>
    <fieldset class="job-profile-readonly" :class="expand === true ? '' : 'bordered'">
        <button v-if="expand === false" @click.prevent="expanded = !expanded" type="button" class="button small" :class="expanded ? 'expanded' : 'collapsed'">{{ expanded ? 'Collapse' : 'Expand' }}</button>

        <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
            <div class="cell low-opacity" :class="compact === true ? 'auto' : 'medium-6 large-4'">
                <label>Job Profile Title *</label>

                <div class="textarea" v-html="removePTag(jobProfile.title)"></div>
            </div>

            <input-emit-button v-if="inputsClickable" @click="() => $emit('input-clicked', 'Job Profile Title', jobProfile.title)" />

            
        </div>

        <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
            <div class="cell low-opacity" :class="compact === true ? 'auto' : 'medium-6 large-4'">
                <label>Reporting To</label>

                <div class="textarea" v-html="removePTag(jobProfile.reporting_to)"></div>
            </div>

            <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Reporting To', jobProfile.reporting_to)" />
        </div>

        <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
            <div class="cell low-opacity" :class="compact === true ? 'auto' : 'medium-6 large-4'">
                <label>Job Purpose</label>

                <div class="textarea" v-html="removePTag(jobProfile.purpose)"></div>
            </div>

            <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Purpose', jobProfile.purpose)" />
        </div>

        <div v-if="twoColumn">
            <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
                <div class="cell low-opacity medium-4">
                    <label>Key Performance Indicators</label>
                    <div class="html-content" v-html="removePTag(jobProfile.kpi)"></div>
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Key Performance Indicators', jobProfile.kpi)" />
                <div class="cell low-opacity medium-4">
                    <label>Knowledge</label>

                    <div class="html-content" v-html="jobProfile.knowledge"></div>
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Knowledge', jobProfile.knowledge)" />
            </div>
            <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
                <div class="cell low-opacity medium-4">
                    <label>Skills</label>

                    <div class="html-content" v-html="removePTag(jobProfile.skills)"></div>
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Skills', jobProfile.skills)" />
                <div class="cell low-opacity medium-4">
                    <label>Attributes</label>

                    <div class="html-content" v-html="removePTag(jobProfile.attributes)"></div>
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Attributes', jobProfile.attributes)" />
            </div>
        </div>
        <div v-else>
            <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
                <div class="cell low-opacity" :class="compact === true ? 'auto' : 'medium-6 large-5'">
                    <label>Key Performance Indicators</label>
                    <div class="html-content" v-html="removePTag(jobProfile.kpi)"></div>
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Key Performance Indicators', jobProfile.kpi)" />
            </div>
            <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
                <div class="cell low-opacity" :class="compact === true ? 'auto' : 'medium-6 large-5'">
                    <label>Knowledge</label>

                    <div class="html-content" v-html="removePTag(jobProfile.knowledge)"></div>
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Knowledge', jobProfile.knowledge)" />
            </div>
            <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
                <div class="cell low-opacity" :class="compact === true ? 'auto' : 'medium-6 large-5'">
                    <label>Skills</label>

                    <div class="html-content" v-html="removePTag(jobProfile.skills)"></div>
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Skills', jobProfile.skills)" />
            </div>
            <div v-show="expanded" class="grid-x grid-padding-x" :class="this.readonlyGridPosition">
                <div class="cell low-opacity" :class="compact === true ? 'auto' : 'medium-6 large-5'">
                    <label>Attributes</label>

                    <div class="html-content" v-html="removePTag(jobProfile.attributes)"></div>
                </div>
                <input-emit-button v-if="inputsClickable" container-class="cell small-2" @click="() => $emit('input-clicked', 'Attributes', jobProfile.attributes)" />
            </div>
        </div>
    </fieldset>
</template>

<style>

.low-opacity {
    opacity: .6;
}

.full-textarea {
    height: auto;
}

</style>
